var itemsRaccomandatore = null;

/* search module */
(function(){
	if(typeof GZheader === "undefined") { GZheader = {}; }

	var search_input,
		search_form,
		search_button,
		search_params,
		search_close_button,
		search_input_placeholder,
		header,
		scrollTop,
		scrollOffset;

	function init(params){
		if(typeof params !== "undefined" && Object.keys(params).length > 0){
			search_params = params;
		} else {
			search_params = {};
		}

		search_container = document.getElementsByClassName("gz-header-search-container")[0];
		search_input = document.getElementsByClassName("gz-header-search-input")[0];
		search_form = document.getElementsByClassName("gz-header-search-form")[0];
		search_button = document.getElementById("gz-header-search");
		search_close_button = document.getElementById("gz-header-search-close");
		search_input_placeholder = search_params.placeholder ? search_params.placeholder : dictionary.searchARecipe;
		header = document.getElementById("gz-header");
		scrollTop = 0;
		scrollOffset = 50;
		bindHandlers();
	}

	function bindHandlers(){
		search_input.addEventListener('input', handleTyping, false);

		if(search_button && search_close_button){
			search_button.addEventListener('click', toggleSearch, false);
			search_close_button.addEventListener('click', toggleSearch, false);
			if(search_params.submitCallback){
				search_form.addEventListener('submit', function(ev){
					window[search_params.submitCallback](ev);
				}, false);
			}
		}

		if(search_input_placeholder && search_params.visible){
			search_input.placeholder = search_input_placeholder;
		}
	}

	function toggleSearch(ev){
		ev.preventDefault();
		ev.stopImmediatePropagation();
		if(header.classList.contains("gz-header-search-opened")){
			header.classList.remove("gz-header-search-opened");
			setTimeout(() => {
				search_container.style.display = "none";
			}, 50);
			search_input.blur();
			window.removeEventListener("scroll", handleScroll);
		} else {
			search_input.focus();
			search_input.placeholder = search_input_placeholder;
			search_container.style.display = "grid";
			setTimeout(() => {
				header.classList.add("gz-header-search-opened");
			}, 50);

			if(device != "desktop") {
				window.addEventListener("scroll", handleScroll, false);
			}
		}
	}

	function handleTyping(ev){
		if(search_input.value.length != 0){
			search_container.classList.add("gz-header-search-active");
		} else {
			search_container.classList.remove("gz-header-search-active");
		}
	}

	function handleScroll(ev) {
		scrollTop = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
		if(scrollTop > scrollOffset){
			closeSearch();
		}
	}

	function closeSearch(ev){
		if(header.classList.contains("gz-header-search-opened")){
			header.classList.remove("gz-header-search-opened");
			search_input.placeholder = "";
			search_input.blur();
			window.removeEventListener("scroll", handleScroll);
		}
	}

	GZheader.search = init;
}());

/* build user menu module */
(function(){
	if(typeof GZheader === "undefined") { GZheader = {}; }

	var html,
		body,
		user_login_icon;

	function init(){
		html = document.getElementsByTagName("html")[0];
		body = document.getElementsByTagName("body")[0];
		user_login_icon = document.getElementById("gz-user-login");

		if(user_login_icon){
			bindHandlers();
		}
	}

	function bindHandlers(){
		if(status1) {
			user_login_icon.removeEventListener("click", openLogin, false);
			user_login_icon.addEventListener("click", openUserProfile, false);
		} else {
			user_login_icon.addEventListener("click", openLogin, false);
		}
	}

	function openLogin(ev) {
		let openLoginEvent = new CustomEvent('openLogin', {detail: {redirect_url: window.location.href}});
		document.dispatchEvent(openLoginEvent);

		eventAnalytics('Apertura modale sloggato', 'Login', window.location.href);
	}

	function openUserProfile(ev) {
		window.location.href = "https://www.giallozafferano.it/utente/index/";
	}
	
	GZheader.userMenu = init;
}());

/* menuManager module */
(function(){
	if(typeof GZheader === "undefined") { GZheader = {}; }

	var children;

	function init(){
		if(!document.getElementById("gz-header-nav") || !document.getElementById("gz-header-overlay-nav")){
			return;
		}
		
		children = document.querySelectorAll(".gz-header-has-children");

		for(var i = 0; i < children.length; i++) {
			buildAccordion(children[i]);
		}

		checkSelected("nav");
		checkSelected("overlay-nav");
	}

	function checkSelected(navType){
		var nav = document.getElementById("gz-header-" + navType);
		var selectedElements = nav.querySelectorAll(".selected");

		if(selectedElements.length > 0){
			var lastOfSelected = selectedElements[selectedElements.length-1];

			for (var i = (navType == "nav") ? 1 : 0; i < selectedElements.length; i++) {
				if(selectedElements[i] != lastOfSelected && selectedElements[i].classList.contains("selected")){
					selectedElements[i].classList.remove("selected");
				}
			}
		}
	}

	function buildAccordion(item){
	    var target = item;
	    if(target.classList.contains("selected")){
	    	target.classList.add("opened");
	    }

	    var links = target.querySelectorAll('.gz-header-has-children a');
	    for (var i = 0; i < links.length; i++) {
		    links[i].addEventListener('click', function (ev) {
		        ev.stopPropagation();
		    });
	    }

	    target.addEventListener('click', handleAccordion, false);
	}

	function handleAccordion(ev){
		ev.preventDefault();
		ev.stopPropagation();
		var currentTarget = this;

		if(currentTarget.classList.contains("opened")){
			currentTarget.classList.remove("opened");
		} else {
			checkOpened();
			currentTarget.classList.add("opened");
		}
	}

	function checkOpened(){
		var overlay_nav = document.getElementById("gz-header-overlay-nav");
		var opened = overlay_nav.querySelectorAll('.opened');

		if(opened.length){
			for(var i = 0; i<opened.length; i++){
				opened[i].classList.remove("opened");
			}
		}
	}

	GZheader.menuManager = init;
}());

/* stickyHeader module */
(function(){
	if(typeof GZheader === "undefined") { GZheader = {}; }

	var body,
		header,
		nav,
		secondLevelNavs,
		strip_adv,
		pamela,
		stuck;

	function init(){
		body = document.getElementsByTagName("body")[0];
		header = document.getElementById("gz-header");
		nav = document.getElementById("gz-header-nav");
		secondLevelNavs = nav ? nav.querySelectorAll('.gz-header-mainmenu') : null;
		strip_adv = document.getElementById("gpt_strip_adv");
		pamela = document.getElementById("av-pushdown-wrapper");
		stuck = false;

		if(device == "desktop" || (typeof sticky_active !== 'undefined' && sticky_active)) {
			window.addEventListener("scroll", handleSticky);
		}
	}

	function getOffsetTop(){
		var offset = 0;

		return offset;
	}

	function handleSticky(){
		// var stick_point = getOffsetTop() + strip_adv.offsetHeight + pamela.offsetHeight;
		var stick_point = getOffsetTop() + (document.getElementById("mh2021") ? document.getElementById("mh2021").firstElementChild.offsetHeight : 0);
		var distance = stick_point - window.pageYOffset;
		var offset = window.pageYOffset;

		if(!body.classList.contains("pushing")){
			if (distance <= 0 && !stuck) {
				body.classList.add("gz-sticky");
				header.classList.add("gz-header-sticky");
				stuck = true;
			} else if (stuck && (offset <= stick_point)){
				body.classList.remove("gz-sticky");
				header.classList.remove("gz-header-sticky");
				stuck = false;
			}
		}

		if(!secondLevelNavs){
			return;
		}
		
		positionSecondLevelNavs();
	}

	function positionSecondLevelNavs(){
		if(!body.classList.contains("pushing")){
			for (var i = 0; i < secondLevelNavs.length; i++) {
				var ul = secondLevelNavs[i];
				if(header.classList.contains("gz-header-sticky")){
					ul.style.top = "auto";
				}else{
					ul.style.top = getOffsetTop() + 55 + (document.getElementById("mh2021") ? document.getElementById("mh2021").firstElementChild.offsetHeight : 0);
				}
			}
		}
	}

	GZheader.stickyHeader = init;
}());

/* handlers module */
(function(){
	if(typeof GZheader === "undefined") { GZheader = {}; }

	var body,
		html,
		hamburger,
		close_button,
		close_panel,
		open_menu,
		nav_overflow_menu,
		pageYOffset;

	function init(){
		html = document.getElementsByTagName("html")[0];
		body = document.getElementsByTagName("body")[0];
		hamburger = document.getElementById("gz-header-hamburger");
		user_login = document.getElementById("gz-user-login");
		open_menu = document.getElementsByClassName("gz-header-open-menu");
		close_button = document.getElementById("gz-header-overlay-close");
		close_panel = document.getElementById("gz-header-overlay-close-panel");
		nav_overflow_menu = document.getElementById("gz-header-nav-overflow-menu");
		header_overlay = document.getElementById("gz-header-overlay");
		lang_switch = document.getElementById("gz-header-translation-link");
		bindHandlers();
	}

	function bindHandlers(){
		hamburger.addEventListener("click", toggleOverlay, false);
		for (var i = 0; i < open_menu.length; i++) {
			open_menu[i].addEventListener("click", toggleOverlay, false);
		}
		close_button.addEventListener("click", toggleOverlay, false);
		if(nav_overflow_menu){
			nav_overflow_menu.addEventListener("click", toggleOverlay, false);
		}		
		close_panel.addEventListener("click", hideOverlay, false);

		if (lang_switch) {
			lang_switch.addEventListener('click', event => {
				eventAnalytics('Click su bandierine in header', 'Interazione', window.location.href);
			});
		}

		// click su "lingue"
		for (const el of document.querySelectorAll(".gz-header-flag")) {
			el.addEventListener('click', event => {
				eventAnalytics('Click su bandierine in burger', 'Interazione', el.dataset.lang);
			});
		}
	}

	function toggleOverlay(ev){
		ev.preventDefault();
		ev.stopImmediatePropagation();
		if(body.classList.contains("gz-header-overlay-opened")){
			body.classList.remove("gz-header-overlay-opened");
			window.scrollTo(0,pageYOffset);
			document.removeEventListener("touchmove", preventScroll, false);
		} else {
			pageYOffset = window.pageYOffset;
			body.classList.add("gz-header-overlay-opened");
			document.addEventListener("touchmove", preventScroll, false);
		}
	}

	function preventScroll(ev){
	    if(!findParentByClassName(ev.target, "gz-header-overlay-opened")){
	    	ev.preventDefault();
	    }
	}

	function hideOverlay(ev){
		if(body.classList.contains("gz-header-overlay-opened")){
			body.classList.remove("gz-header-overlay-opened");
			document.removeEventListener("touchmove", preventScroll, false);
		}
	}

	function findParentByClassName(el,className) {
    	while (el.parentNode && el.parentElement !== html) {
        	el = el.parentNode;
        	if (el.classList.contains(className)){
            	return el;
        	}
    	}
    	return null;
	}

	GZheader.handlers = init;
}());

/*
Inizializzazione GZheader
- popolamento logo
- popolamento del menù di navigazione presente nell'overlay
- gestione del funzionamento del menù
- gestione sticky header allo scroll
- bind eventi generici
*/
if(typeof GZheaderOptions !== "undefined") {
	(function(o){
		if(typeof o === "undefined") { return; }
		var GZheaderOptions = JSON.parse(JSON.stringify(o));
	
		GZheader.menuManager();
		GZheader.stickyHeader();
		GZheader.userMenu();
		GZheader.handlers();
	
		for(var i in GZheaderOptions){
			if(i !== "topstrip"){
				if(GZheaderOptions[i]){
					if(GZheader[i]){
						if(typeof GZheaderOptions[i] !== "boolean"){
							GZheader[i](GZheaderOptions[i]);
						} else {
							GZheader[i]();
						}
					}
				} 
			}
		}
	})(GZheaderOptions);
}